import React, { ReactElement } from 'react';
import { Immutable, safeRest } from '@wds/utils';

import useStyles from './useStyles';
import { VariantComponent } from '../../variants';

export type NavigationProps = Immutable<{
  items: VariantComponent;
}>;

const Navigation = ({ items, ...rest }: NavigationProps): ReactElement => {
  const classes = useStyles();

  return (
    <nav className={classes.navigation} {...safeRest(rest)}>
      <ul>{items}</ul>
    </nav>
  );
};

export default Navigation;
export { Navigation };
